var languageData = JSON.parse(localStorage.getItem('idiom'));

export const officePageData = languageData?.OFC;
export const parentOrgPageData = languageData?.PRT;
export const genPageData = languageData?.GEN ? languageData?.GEN : '';
export const errorPageData = languageData?.ERR ? languageData?.ERR : '';
export const publicPageData = languageData?.PUB ? languageData?.PUB : '';
